import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const PremiumOfferBookedBadge = () => {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s4"
      paddingY="s4"
      paddingX="s12"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs010' }}
    >
      <Icon.Small icon="check" />
      <Text.Normal color="grey600" size="200" weight="medium">
        {i18n.t('ats.job_details.marketplace.common.booked_badge')}
      </Text.Normal>
    </Box>
  )
}
